// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles__marginBottom___VjtmH {
  margin-bottom: 20px;
}
.styles__infoPropertyName___Rfx1N {
  color: #7F7F7F;
  margin-right: 4px;
  font-size: 12px;
}
.styles__inline___hvkun {
  display: flex;
  font-size: 14px;
  align-items: center;
}
.styles__property___zc0Df {
  align-items: center;
}
.styles__row___zXlhq {
  width: 100%;
  display: flex;
  flex-direction: column;
}
@media (min-width: 991px) {
  .styles__row___zXlhq {
    flex-direction: row;
    align-items: center;
  }
}
@media (max-width: 991px) {
  .styles__topItem___cTRmS {
    padding-top: 24px;
    border-bottom: 1px solid #ccc !important;
    display: flex;
    justify-content: center;
  }
}
.styles__bottomItem___HsyRW {
  padding-bottom: 0px;
  padding-top: 0px;
}
@media (max-width: 991px) {
  .styles__bottomItem___HsyRW {
    padding-top: 20px;
    padding-bottom: 20px;
    border-bottom: 1px solid #ccc !important;
  }
}
.styles__properties___WCyIA {
}
@media (min-width: 992px) {
  .styles__properties___WCyIA {
    padding-left: 0 !important;
    padding-right: 0 !important;
  }
}
.styles__properties___WCyIA div {
  line-height: 24px;
}
.styles__flexIt___KS8x0 {
  display: flex;
  align-items: center;
}
.styles__img___sH_CB {
  border: none;
  margin-left: -5px;
  width: 120px;
  vertical-align: top;
}
.styles__productThumbnail___fO1Zx {
  float: left;
  width: 120px;
  height: 120px;
  overflow: hidden;
  text-align: center;
  cursor: pointer;
}
.styles__product___Z5lUy {
  padding-right: 15px;
  padding-top: 20px;
  padding-bottom: 20px;
  margin-bottom: 20px;
  background: #fff;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}
@media (min-width: 991px) {
  .styles__product___Z5lUy {
    height: 180px;
  }
}
@media (max-width: 991px) {
  .styles__product___Z5lUy {
    flex-direction: column;
    padding-bottom: 0px;
  }
}
.styles__titleColumn___BNJkx {
  display: flex;
  align-items: center;
}
@media (max-width: 991px) {
  .styles__titleColumn___BNJkx {
    border-bottom: 1px solid #ccc;
    justify-content: center;
  }
}
.styles__titleWidth___rM6NO {
  max-width: calc(100% - 120px);
}
.styles__productTitle___h0AJw {
  font-weight: 400;
  font-size: 18px;
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  text-decoration: underline;
}
.styles__smFull___R_ffT {
  width: auto;
}
@media (max-width: 991px) {
  .styles__smFull___R_ffT {
    min-width: 270px;
    width: 100%;
    height: 48px;
  }
}
.styles__buttonGroup___SWNe3 {
}
@media (min-width: 992px) {
  .styles__buttonGroup___SWNe3 {
    margin-top: 20px;
  }
}
@media (max-width: 991px) {
  .styles__colFullSize___B1Erq {
    padding: 0 !important;
    margin-left: -55px;
    margin-right: -55px;
    margin-bottom: -20px;
  }
}
.styles__commentInput___yNYeG {
  border: none !important;
  box-shadow: none !important;
  border-bottom: 1px solid #ccc !important;
}
.styles__quantityInCartSm___YlGb4 {
  text-align: right;
  width: 100%;
  padding-bottom: 20px;
}
@media (min-width: 992px) {
  .styles__quantityInCartSm___YlGb4 {
    display: none;
  }
}
.styles__quantityInCartMd___oJFvg {
  text-align: right;
  width: 100%;
}
@media (max-width: 991px) {
  .styles__quantityInCartMd___oJFvg {
    display: none;
  }
}
.styles__rimDescription___YNxjF {
  white-space: nowrap;
  overflow: hidden;
}
.styles__typeAndTestResults___F3DJo {
  margin-bottom: 5px;
}
.styles__euGrading___WoaKd {
  margin-bottom: 5px;
}
.styles__testResults___uz4gL {
  margin-left: 0px;
}
.styles__bonus___N7uYH {
  display: flex;
  justify-content: flex-end;
}
.styles__priceColumn___T4kVW {
  text-align: right;
}
@media (max-width: 991px) {
  .styles__priceColumn___T4kVW {
    padding-top: 20px;
  }
}
.styles__price___EaiTa {
  font-size: 20px;
  font-weight: bold;
}
.styles__priceInfo___4DH0W {
  display: flex;
  flex-direction: column;
  white-space: nowrap;
  margin-left: 12px;
}
@media (max-width: 991px) {
  .styles__priceInfo___4DH0W {
    padding-bottom: 20px;
    padding-top: 20px;
    text-align: right;
  }
}
.styles__controls___mpoJH {
  padding-left: 20px;
  padding-right: 20px;
}
@media (min-width: 992px) {
  .styles__controls___mpoJH {
    display: flex;
    align-items: center;
    padding-left: 0px;
    padding-right: 0px;
  }
}
.styles__comment___S7BSk {
  margin-top: 8px;
  color: #D9534F;
}
.styles__limitedQuantityMessage___ZxjCw {
  color: #d9534f;
}
`, "",{"version":3,"sources":["webpack://./src/components/components/Search/SearchResults/ProductsList/CompleteWheelProduct/styles.less"],"names":[],"mappings":"AAEA;EACE,mBAAA;AADF;AAIA;EACE,cAAA;EACA,iBAAA;EACA,eAAA;AAFF;AAKA;EACE,aAAA;EACA,eAAA;EACA,mBAAA;AAHF;AAMA;EAEE,mBAAA;AAJF;AAOA;EACE,WAAA;EACA,aAAA;EACA,sBAAA;AALF;AAME;EAAA;IACE,mBAAA;IACA,mBAAA;EAHF;AACF;AAOE;EAAA;IACE,iBAAA;IACA,wCAAA;IACA,aAAA;IACA,uBAAA;EAJF;AACF;AAOA;EACE,mBAAA;EACA,gBAAA;AALF;AAME;EAAA;IACE,iBAAA;IACA,oBAAA;IACA,wCAAA;EAHF;AACF;AAMA;AAHA;AAKE;EAAA;IACE,0BAAA;IACA,2BAAA;EAFF;AACF;AAHA;EAOI,iBAAA;AADJ;AAKA;EACE,aAAA;EACA,mBAAA;AAHF;AAMA;EACE,YAAA;EACA,iBAAA;EACA,YAAA;EACA,mBAAA;AAJF;AAOA;EACE,WAAA;EACA,YAAA;EACA,aAAA;EACA,gBAAA;EACA,kBAAA;EACA,eAAA;AALF;AAQA;EAEE,mBAAA;EACA,iBAAA;EACA,oBAAA;EACA,mBAAA;EACA,gBAAA;EACA,gBAAA;EACA,aAAA;EACA,sBAAA;AANF;AAOE;EAAA;IACE,aAAA;EAJF;AACF;AAKE;EAAA;IACE,sBAAA;IACA,mBAAA;EAFF;AACF;AAKA;EACE,aAAA;EACA,mBAAA;AAHF;AAIE;EAAA;IACE,6BAAA;IACA,uBAAA;EADF;AACF;AAGA;EACE,6BAAA;AADF;AAIA;EACE,gBAAA;EACA,eAAA;EACA,cAAA;EACA,gBAAA;EACA,uBAAA;EACA,0BAAA;AAFF;AAKA;EACE,WAAA;AAHF;AAIE;EAAA;IACE,gBAAA;IACA,WAAA;IACA,YAAA;EADF;AACF;AAIA;AADA;AAGE;EAAA;IACE,gBAAA;EAAF;AACF;AAIE;EAAA;IACE,qBAAA;IACA,kBAAA;IACA,mBAAA;IACA,oBAAA;EADF;AACF;AAIA;EACE,uBAAA;EACA,2BAAA;EACA,wCAAA;AAFF;AAKA;EACE,iBAAA;EACA,WAAA;EACA,oBAAA;AAHF;AAIE;EAAA;IACE,aAAA;EADF;AACF;AAIA;EACE,iBAAA;EACA,WAAA;AAFF;AAGE;EAAA;IACE,aAAA;EAAF;AACF;AAGA;EAEE,mBAAA;EACA,gBAAA;AADF;AAIA;EAGE,kBAAA;AAFF;AAKA;EACE,kBAAA;AAHF;AAMA;EACE,gBAAA;AAJF;AAOA;EACE,aAAA;EACA,yBAAA;AALF;AAQA;EACE,iBAAA;AANF;AAOE;EAAA;IACE,iBAAA;EAJF;AACF;AAOA;EACE,eAAA;EACA,iBAAA;AALF;AAQA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,iBAAA;AANF;AAOE;EAAA;IACE,oBAAA;IACA,iBAAA;IACA,iBAAA;EAJF;AACF;AAOA;EACE,kBAAA;EACA,mBAAA;AALF;AAME;EAAA;IACE,aAAA;IACA,mBAAA;IACA,iBAAA;IACA,kBAAA;EAHF;AACF;AAMA;EACE,eAAA;EACA,cAAA;AAJF;AAOA;EACE,cAAA;AALF","sourcesContent":["@import '../../../../../../shared/variables.less';\n\n.marginBottom {\n  margin-bottom: 20px;\n}\n\n.infoPropertyName {\n  color: @eon-text-color-muted;\n  margin-right: 4px;\n  font-size: 12px;\n}\n\n.inline {\n  display: flex;\n  font-size: 14px;\n  align-items: center;\n}\n\n.property {\n  composes: inline;\n  align-items: center;\n}\n\n.row {\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  @media (min-width: 991px) {\n    flex-direction: row;\n    align-items: center;\n  }\n}\n\n.topItem {\n  @media (max-width: 991px) {\n    padding-top: 24px;\n    border-bottom: 1px solid #ccc !important;\n    display: flex;\n    justify-content: center;\n  }\n}\n\n.bottomItem {\n  padding-bottom: 0px;\n  padding-top: 0px;\n  @media (max-width: 991px) {\n    padding-top: 20px;\n    padding-bottom: 20px;\n    border-bottom: 1px solid #ccc !important;\n  }\n}\n\n.properties {\n  composes: bottomItem;\n  @media (min-width: @screen-md) {\n    padding-left: 0 !important;\n    padding-right: 0 !important;\n  }\n  div {\n    line-height: 24px;\n  }\n}\n\n.flexIt {\n  display: flex;\n  align-items: center;\n}\n\n.img {\n  border: none;\n  margin-left: -5px;\n  width: 120px;\n  vertical-align: top;\n}\n\n.productThumbnail {\n  float: left;\n  width: 120px;\n  height: 120px;\n  overflow: hidden;\n  text-align: center;\n  cursor: pointer;\n}\n\n.product {\n  composes: flexIt;\n  padding-right: 15px;\n  padding-top: 20px;\n  padding-bottom: 20px;\n  margin-bottom: 20px;\n  background: #fff;\n  overflow: hidden;\n  display: flex;\n  flex-direction: column;\n  @media (min-width: 991px) {\n    height: 180px;\n  }\n  @media (max-width: @screen-sm-max) {\n    flex-direction: column;\n    padding-bottom: 0px;\n  }\n}\n\n.titleColumn {\n  display: flex;\n  align-items: center;\n  @media (max-width: 991px) {\n    border-bottom: 1px solid #ccc;\n    justify-content: center;\n  }\n}\n.titleWidth {\n  max-width: calc(100% - 120px);\n}\n\n.productTitle {\n  font-weight: 400;\n  font-size: 18px;\n  display: block;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  text-decoration: underline;\n}\n\n.smFull {\n  width: auto;\n  @media (max-width: @screen-sm-max) {\n    min-width: 270px;\n    width: 100%;\n    height: 48px;\n  }\n}\n\n.buttonGroup {\n  composes: smFull;\n  @media (min-width: @screen-md-min) {\n    margin-top: 20px;\n  }\n}\n\n.colFullSize {\n  @media (max-width: @screen-sm-max) {\n    padding: 0 !important;\n    margin-left: -55px;\n    margin-right: -55px;\n    margin-bottom: -20px;\n  }\n}\n\n.commentInput {\n  border: none !important;\n  box-shadow: none !important;\n  border-bottom: 1px solid #ccc !important;\n}\n\n.quantityInCartSm {\n  text-align: right;\n  width: 100%;\n  padding-bottom: 20px;\n  @media (min-width: @screen-md-min) {\n    display: none;\n  }\n}\n\n.quantityInCartMd {\n  text-align: right;\n  width: 100%;\n  @media (max-width: @screen-sm-max) {\n    display: none;\n  }\n}\n\n.rimDescription {\n  composes: flexIt;\n  white-space: nowrap;\n  overflow: hidden;\n}\n\n.typeAndTestResults {\n  composes: flexIt;\n  composes: bottomItem;\n  margin-bottom: 5px;\n}\n\n.euGrading {\n  margin-bottom: 5px;\n}\n\n.testResults {\n  margin-left: 0px;\n}\n\n.bonus {\n  display: flex;\n  justify-content: flex-end;\n}\n\n.priceColumn {\n  text-align: right;\n  @media (max-width: @screen-sm-max) {\n    padding-top: 20px;\n  }\n}\n\n.price {\n  font-size: 20px;\n  font-weight: bold;\n}\n\n.priceInfo {\n  display: flex;\n  flex-direction: column;\n  white-space: nowrap;\n  margin-left: 12px;\n  @media (max-width: 991px) {\n    padding-bottom: 20px;\n    padding-top: 20px;\n    text-align: right;\n  }\n}\n\n.controls {\n  padding-left: 20px;\n  padding-right: 20px;\n  @media (min-width: @screen-md-min) {\n    display: flex;\n    align-items: center;\n    padding-left: 0px;\n    padding-right: 0px;\n  }\n}\n\n.comment {\n  margin-top: 8px;\n  color: @eon-text-color-red;\n}\n\n.limitedQuantityMessage {\n  color: @danger;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"marginBottom": `styles__marginBottom___VjtmH`,
	"infoPropertyName": `styles__infoPropertyName___Rfx1N`,
	"inline": `styles__inline___hvkun`,
	"property": `styles__property___zc0Df styles__inline___hvkun`,
	"row": `styles__row___zXlhq`,
	"topItem": `styles__topItem___cTRmS`,
	"bottomItem": `styles__bottomItem___HsyRW`,
	"properties": `styles__properties___WCyIA styles__bottomItem___HsyRW`,
	"flexIt": `styles__flexIt___KS8x0`,
	"img": `styles__img___sH_CB`,
	"productThumbnail": `styles__productThumbnail___fO1Zx`,
	"product": `styles__product___Z5lUy styles__flexIt___KS8x0`,
	"titleColumn": `styles__titleColumn___BNJkx`,
	"titleWidth": `styles__titleWidth___rM6NO`,
	"productTitle": `styles__productTitle___h0AJw`,
	"smFull": `styles__smFull___R_ffT`,
	"buttonGroup": `styles__buttonGroup___SWNe3 styles__smFull___R_ffT`,
	"colFullSize": `styles__colFullSize___B1Erq`,
	"commentInput": `styles__commentInput___yNYeG`,
	"quantityInCartSm": `styles__quantityInCartSm___YlGb4`,
	"quantityInCartMd": `styles__quantityInCartMd___oJFvg`,
	"rimDescription": `styles__rimDescription___YNxjF styles__flexIt___KS8x0`,
	"typeAndTestResults": `styles__typeAndTestResults___F3DJo styles__flexIt___KS8x0 styles__bottomItem___HsyRW`,
	"euGrading": `styles__euGrading___WoaKd`,
	"testResults": `styles__testResults___uz4gL`,
	"bonus": `styles__bonus___N7uYH`,
	"priceColumn": `styles__priceColumn___T4kVW`,
	"price": `styles__price___EaiTa`,
	"priceInfo": `styles__priceInfo___4DH0W`,
	"controls": `styles__controls___mpoJH`,
	"comment": `styles__comment___S7BSk`,
	"limitedQuantityMessage": `styles__limitedQuantityMessage___ZxjCw`
};
export default ___CSS_LOADER_EXPORT___;
